import create from "zustand";

import { useAccountStore } from "base/stores";

import { getFilePickerData } from "../../filepicker/filepicker.service";

export const usePickerDetailsStore = create((set, get) => {
  var filePickerDetails = {
    isReady: false,
    stateCallBack: (data) => {}
  };
  async function getPickerDetails() {
    if (get().config) {
      return get();
    } else {
      const accountId = useAccountStore.getState()._id;
      const [fetchPickerDetails] = getFilePickerData(accountId);
      const details = await fetchPickerDetails();
      filePickerDetails.isReady = true;
      filePickerDetails.config = details;
      filePickerDetails.stateCallBack({ status: "Ready" });
      set(filePickerDetails);
      return filePickerDetails;
    }
  }

  async function setAccessToken(serviceName, accessToken, currentUser) {
    set((state) => {
      state.config[serviceName].AccessToken = accessToken;
      state.config[serviceName].CurrentUser = currentUser;
      return state;
    });
  }

  return {
    getPickerDetails,
    setAccessToken
  };
});
